import {DataTableConfig, FromServerDataTableConfig} from 'notebook/data-tables/DataTableConstants';
import type {AssaySchemaSpec, RunSchemaSpec} from 'schemas/spec/SchemaConfigConstants';
import * as net from 'util/Net';

export interface DataTableConfigsResponse {
  dataTableConfigs: Array<FromServerDataTableConfig>;
}

export function fetchAllDataTableConfigs(): JQueryPromise<DataTableConfigsResponse> {
  return net.getJSON('/1/api/workflows/data-table-configs');
}

type RunResultSchemaSpec = AssaySchemaSpec | RunSchemaSpec;

export interface PublishDataTableConfigResponse {
  dataTableConfig: FromServerDataTableConfig;
  schemaSpec: RunResultSchemaSpec;
}

export function publish(
  dataTableConfig: DataTableConfig,
  {
    columnTypesByCid,
    fieldIdsToDelete,
  }: {columnTypesByCid?: {[cid: string]: string}; fieldIdsToDelete?: Array<number>} = {}
): JQueryPromise<PublishDataTableConfigResponse> {
  return net.postJSON({
    url: '/1/api/workflows/data-table-configs:publish',
    data: {dataTableConfig, fieldIdsToDelete, columnTypesByCid},
  });
}
